import { Flex } from 'antd';

import {
  useAppSelector,
  useRequestTypeFinderById,
  useStatusFinderByNum,
  useUserPermissions,
} from '@Hooks/index';
import { useGetHrmRequestFormQuery } from '@Store/api/basicHrmApiSlice';
import { getModalRecordKey } from '@Store/selectors/modalSelector';

import { Status } from '@Components/Base';
import fieldSource from '../FieldSource';

import { EditAction, FooterActions } from './components';

import styles from './view-mobile-form.module.css';

interface RequestViewMobileFormProps {
  onEdit: (recordKey: string) => void;
  onDeleteRequest: (requestNo: string) => void;
  onSubmitRequest: (requestNo: string) => void;
  onCancelRequest: (requestNo: string) => void;
}

const RequestViewMobileForm: React.FC<RequestViewMobileFormProps> = ({
  onEdit,
  onDeleteRequest,
  onSubmitRequest,
  onCancelRequest,
}) => {
  const { findStatus } = useStatusFinderByNum('Passport');
  const { findRequestType } = useRequestTypeFinderById('Passport');
  const permissions = useUserPermissions();
  const requestId = useAppSelector(getModalRecordKey);
  const { data } = useGetHrmRequestFormQuery(requestId!, {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });

  if (!data) return null;

  const statusRequest = findStatus(data?.reqStatusId)?.codeDesc || '';

  return (
    <Flex vertical>
      <div className={styles.viewMobileForm}>
        {fieldSource(data, findRequestType).map((item) => (
          <div className={styles.viewMobileItem} key={item.label}>
            <span>{item.label}</span>
            {item.label === 'Status' ? (
              <Status
                className={styles.viewMobileItemValue}
                text={findStatus(Number(item.value))?.codeDesc || ''}
              />
            ) : (
              <span className={styles.viewMobileItemValue}>{item.value}</span>
            )}
          </div>
        ))}
      </div>
      <EditAction handleEdit={() => onEdit(requestId)} status={statusRequest} />
      <FooterActions
        handleDeleteRequest={() => onDeleteRequest(requestId)}
        handleSubmitRequest={() => onSubmitRequest(requestId)}
        handleCancelRequest={() => onCancelRequest(requestId)}
        disabledCancelForm={!permissions.can('Cancel', 'Passport')}
        disabledDeleteForm={!permissions.can('Delete', 'Passport')}
        disabledSubmitForm={!permissions.can('Submit', 'Passport')}
        status={statusRequest}
      />
    </Flex>
  );
};

export default RequestViewMobileForm;
